<script>
    export let size = 24
    export let color = '#00669E'
    export let style = ''
    export let title = null
</script>

<svg
    width={`${size}`}
    height={`${size}`}
    {style}
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
>
    {#if title}
        <title>{title}</title>
    {/if}
    <path fill={color} d="M472 168H40a24 24 0 010-48h432a24 24 0 010 48zM392 280H120a24 24 0 010-48h272a24 24 0 010 48zM296 392h-80a24 24 0 010-48h80a24 24 0 010 48z"/>
</svg>